//query params allowed with Campaign Page url
export const CAMPAIGN_PAGE_QUERY_PARAMS = {
  lineitemSearchTerm: "lineitemSearchTerm", //filters lineitem table by lineitem name
  lineitemShowArchived: "lineitemShowArchived", //show archived lineitems in lineitem table
  lineitemFilterBy: "lineitemFilterBy", //filter lineitems by status (running, paused, archived or all)
};
